export default __webpack_public_path__ + "static/media/infoIcon.d3ce6140.svg";